import { LinearProgress } from "@material-ui/core"
import PropTypes from "prop-types"
import { useContext, useEffect, useState } from "react"
import CertificationCardList from "~/components/Certifications/CertificationCardList"
import AdminActionBar from "~/components/Common/AdminActionBar"
import StatusFilters from "~/components/Common/StatusFilters"
import AppContext from "~/contexts/App"
import CertificationsContext from "~/contexts/Certifications"
import Page from "~/pages/Page"
import Router from "~/router"
import Box from "../../../../components/Common/Box"
import useStyles from "./styles"

const CertificationsList = ({ routes = [], ...rest }) => {
  const classes = useStyles()
  const { openDialog, setPageSubTitle, setPageTitle } = useContext(AppContext)
  const { certifications, certifcationsLoading, createCertMutation } =
    useContext(CertificationsContext)

  const filterOptions = [
    { id: 1, name: "Name" },
    { id: 2, name: "Learning Paths" },
    { id: 3, name: "Last Updated" },
  ]

  //set serach value
  const [searchValue, setSearchValue] = useState("")

  //set sort data
  const [sort, setSort] = useState({
    name: "",
    type: "",
    direction: "",
    icon: "",
  })

  const hash = window.location.hash
    ? window.location.hash.replace("#", "")
    : "published"
  //Certification Status
  const [statusState, setStatusState] = useState(hash)
  const watchHash = () => {
    const newHash = window.location.hash.replace("#", "")
    if (newHash) {
      setStatusState(newHash)
    }
  }
  useEffect(() => {
    window.removeEventListener("hashchange", watchHash)
    window.addEventListener("hashchange", watchHash, false)
  })
  const [statusNumber, setStatusNumber] = useState({
    published: null,
    unpublished: null,
    draft: null,
  })

  //create certification dialog
  const openCreateDialog = () => {
    let data = {
      create: createCertMutation,
    }
    openDialog("createCertificationDialog", data)
  }

  //set learning paths title and subtitle
  useEffect(() => {
    setPageTitle("Certifications")
    setPageSubTitle(certifications?.length)
  }, [certifications])

  if (sort?.direction === "") {
    sort.name = ""
    sort.type = ""
  }

  return (
    <Page>
      <AdminActionBar
        buttonName="New Certification"
        buttonFunc={openCreateDialog}
        sortOptions={filterOptions}
        sortState={sort}
        setSortState={setSort}
        setFilterState={setSearchValue}
        placeholder="Search Certifications"
      />
      {certifcationsLoading ? (
        <LinearProgress color="primary" />
      ) : (
        <Box
          display="flex"
          height="calc(100% - 60px)"
          flexWrap="wrap"
          className={classes.container}
        >
          <Box className={classes.leftContainer}>
            <StatusFilters
              setStatusState={setStatusState}
              statusState={statusState}
              statusNumber={statusNumber}
              type="certifications"
            />
          </Box>
          <Box className={classes.rightContainer}>
            <CertificationCardList
              searchValue={searchValue}
              sort={sort}
              openCreateDialog={openCreateDialog}
              setStatusNumber={setStatusNumber}
              statusState={statusState}
              certifications={certifications}
            />
          </Box>
        </Box>
      )}

      <Router routes={routes} {...rest} />
    </Page>
  )
}

CertificationsList.propTypes = {
  routes: PropTypes.array,
}

export default CertificationsList
